/* eslint-disable import/prefer-default-export */
export function updateItemById(list, updated) {
  const index = list.findIndex((item) => item.id === updated.id);
  // return list;

  return [...list.slice(0, index), updated, ...list.slice(index + 1)];
}
